import React, { useState, useEffect } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import LeftCard from "../../components/messages/leftcard";
import Rightcard from "../../components/messages/rightcard";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../api";
import { useSearchParams } from 'react-router-dom';
const Messages = () => {
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [searchParams] = useSearchParams();
  const conversationId = searchParams.get("conversation");
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="position-relative">
      {loading && <Spinner />}

      <div style={{ display: loading ? "none" : "block" }}>
        <div className="main-chart-wrapper pt-0 p-1 gap-2 d-lg-flex">
          <LeftCard
            selectedConversation={selectedExpert}
            onSelectConversation={setSelectedExpert}
             conversationId={conversationId}
            onLoaded={() => setLoading(false)}
          />
          <Rightcard conversation={selectedExpert}
           conversationId={conversationId} />
        </div>
      </div>
    </div>
  );
};

export default Messages;
